import _classCallCheck from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _get from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/get";
import _inherits from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/model/operation/rootattributeoperation
 */
import Operation from "./operation";
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
/**
 * Operation to change root element's attribute. Using this class you can add, remove or change value of the attribute.
 *
 * This operation is needed, because root elements can't be changed through
 * @link module:engine/model/operation/attributeoperation~AttributeOperation}.
 * It is because {@link module:engine/model/operation/attributeoperation~AttributeOperation}
 * requires a range to change and root element can't
 * be a part of range because every {@link module:engine/model/position~Position} has to be inside a root.
 * {@link module:engine/model/position~Position} can't be created before a root element.
 *
 * @extends module:engine/model/operation/operation~Operation
 */

var RootAttributeOperation =
/*#__PURE__*/
function (_Operation) {
  _inherits(RootAttributeOperation, _Operation);

  /**
   * Creates an operation that changes, removes or adds attributes on root element.
   *
   * @see module:engine/model/operation/attributeoperation~AttributeOperation
   * @param {module:engine/model/rootelement~RootElement} root Root element to change.
   * @param {String} key Key of an attribute to change or remove.
   * @param {*} oldValue Old value of the attribute with given key or `null` if adding a new attribute.
   * @param {*} newValue New value to set for the attribute. If `null`, then the operation just removes the attribute.
   * @param {Number|null} baseVersion Document {@link module:engine/model/document~Document#version} on which operation
   * can be applied or `null` if the operation operates on detached (non-document) tree.
   */
  function RootAttributeOperation(root, key, oldValue, newValue, baseVersion) {
    var _this;

    _classCallCheck(this, RootAttributeOperation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RootAttributeOperation).call(this, baseVersion));
    /**
     * Root element to change.
     *
     * @readonly
     * @member {module:engine/model/rootelement~RootElement}
     */

    _this.root = root;
    /**
     * Key of an attribute to change or remove.
     *
     * @readonly
     * @member {String}
     */

    _this.key = key;
    /**
     * Old value of the attribute with given key or `null` if adding a new attribute.
     *
     * @readonly
     * @member {*}
     */

    _this.oldValue = oldValue;
    /**
     * New value to set for the attribute. If `null`, then the operation just removes the attribute.
     *
     * @readonly
     * @member {*}
     */

    _this.newValue = newValue;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(RootAttributeOperation, [{
    key: "clone",

    /**
     * Creates and returns an operation that has the same parameters as this operation.
     *
     * @returns {module:engine/model/operation/rootattributeoperation~RootAttributeOperation} Clone of this operation.
     */
    value: function clone() {
      return new RootAttributeOperation(this.root, this.key, this.oldValue, this.newValue, this.baseVersion);
    }
    /**
     * See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
     *
     * @returns {module:engine/model/operation/rootattributeoperation~RootAttributeOperation}
     */

  }, {
    key: "getReversed",
    value: function getReversed() {
      return new RootAttributeOperation(this.root, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "_validate",
    value: function _validate() {
      if (this.root != this.root.root || this.root.is('documentFragment')) {
        /**
         * The element to change is not a root element.
         *
         * @error rootattribute-operation-not-a-root
         * @param {module:engine/model/rootelement~RootElement} root
         * @param {String} key
         * @param {*} value
         */
        throw new CKEditorError('rootattribute-operation-not-a-root: The element to change is not a root element.', this, {
          root: this.root,
          key: this.key
        });
      }

      if (this.oldValue !== null && this.root.getAttribute(this.key) !== this.oldValue) {
        /**
         * The attribute which should be removed does not exists for the given node.
         *
         * @error rootattribute-operation-wrong-old-value
         * @param {module:engine/model/rootelement~RootElement} root
         * @param {String} key
         * @param {*} value
         */
        throw new CKEditorError('rootattribute-operation-wrong-old-value: Changed node has different attribute value than operation\'s ' + 'old attribute value.', this, {
          root: this.root,
          key: this.key
        });
      }

      if (this.oldValue === null && this.newValue !== null && this.root.hasAttribute(this.key)) {
        /**
         * The attribute with given key already exists for the given node.
         *
         * @error rootattribute-operation-attribute-exists
         * @param {module:engine/model/rootelement~RootElement} root
         * @param {String} key
         */
        throw new CKEditorError('rootattribute-operation-attribute-exists: The attribute with given key already exists.', this, {
          root: this.root,
          key: this.key
        });
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "_execute",
    value: function _execute() {
      if (this.newValue !== null) {
        this.root._setAttribute(this.key, this.newValue);
      } else {
        this.root._removeAttribute(this.key);
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = _get(_getPrototypeOf(RootAttributeOperation.prototype), "toJSON", this).call(this);

      json.root = this.root.toJSON();
      return json;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "type",
    get: function get() {
      if (this.oldValue === null) {
        return 'addRootAttribute';
      } else if (this.newValue === null) {
        return 'removeRootAttribute';
      } else {
        return 'changeRootAttribute';
      }
    }
  }], [{
    key: "fromJSON",

    /**
     * Creates RootAttributeOperation object from deserilized object, i.e. from parsed JSON string.
     *
     * @param {Object} json Deserialized JSON object.
     * @param {module:engine/model/document~Document} document Document on which this operation will be applied.
     * @returns {module:engine/model/operation/rootattributeoperation~RootAttributeOperation}
     */
    value: function fromJSON(json, document) {
      if (!document.getRoot(json.root)) {
        /**
         * Cannot create RootAttributeOperation for document. Root with specified name does not exist.
         *
         * @error rootattributeoperation-fromjson-no-root
         * @param {String} rootName
         */
        throw new CKEditorError('rootattribute-operation-fromjson-no-root: Cannot create RootAttributeOperation. Root with specified name does not exist.', this, {
          rootName: json.root
        });
      }

      return new RootAttributeOperation(document.getRoot(json.root), json.key, json.oldValue, json.newValue, json.baseVersion);
    }
  }, {
    key: "className",
    get: function get() {
      return 'RootAttributeOperation';
    }
  }]);

  return RootAttributeOperation;
}(Operation);

export { RootAttributeOperation as default };